import { type PendingSmartResizeHandoff, useEditCanvasStore } from '../store';

/**
 * Opens the smart-resize picker on an image or video node from a handoff outside the canvas
 * toolbar. The picker reads the handoff when it mounts, so it is set before the open request.
 */
export const openSmartResizePickerForNode = (handoff: PendingSmartResizeHandoff) => {
  const { setPendingSmartResizeHandoff, setPendingSmartResizeOpenNodeId } = useEditCanvasStore.getState();

  setPendingSmartResizeHandoff(handoff);
  setPendingSmartResizeOpenNodeId(handoff.nodeId);
};
